import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditSessionPayload {
    id: string
    data: any
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editSession = createSlice({
    name: 'session/edit-session',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<IEditSessionPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editSessionActions = editSession.actions
export default editSession.reducer
